/**
 * Может ли этот браузер звонить (изменение v1.14, CLIENT_WEB §rtc).
 *
 * Звонку нужны три вещи: WebRTC (`RTCPeerConnection`), микрофон (`getUserMedia`) и Web Crypto
 * с ECDH P-256 — сквозное шифрование сигналинга. Микрофон и Web Crypto браузер даёт только в
 * secure context (HTTPS или localhost): на http-странице звонок честно недоступен, а не падает.
 */
export type CallUnsupportedReason = 'insecure_context' | 'no_webrtc' | 'no_microphone' | 'no_crypto'

export type CallSupport = { ok: true } | { ok: false; reason: CallUnsupportedReason }

export async function checkCallSupport(): Promise<CallSupport> {
  if (globalThis.isSecureContext === false) return { ok: false, reason: 'insecure_context' }
  if (typeof globalThis.RTCPeerConnection !== 'function') return { ok: false, reason: 'no_webrtc' }
  if (typeof globalThis.navigator?.mediaDevices?.getUserMedia !== 'function') {
    return { ok: false, reason: 'no_microphone' }
  }
  // Проба криптографии тянет модуль шифрования звонка — грузим его, только когда звонят.
  const { isCallCryptoSupported } = await import('@shared/crypto/call')
  if (!(await isCallCryptoSupported())) return { ok: false, reason: 'no_crypto' }
  return { ok: true }
}

export function callUnsupportedMessage(reason: CallUnsupportedReason): string {
  switch (reason) {
    case 'insecure_context':
      return 'Звонки работают только по защищённому соединению (HTTPS).'
    case 'no_webrtc':
      return 'Этот браузер не умеет звонить. Обновите его или откройте «Движ» в другом браузере.'
    case 'no_microphone':
      return 'Браузер не даёт доступа к микрофону — звонить из него нельзя.'
    case 'no_crypto':
      return 'Браузер не поддерживает шифрование звонков. Обновите его.'
  }
}
